import { defineComponent as _defineComponent } from 'vue'
import { usePhotoStore } from "@/stores/photostore";
import {onMounted} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageGallery',
  setup(__props) {


const photoStore = usePhotoStore();

function clickedImage(index: number) {
    photoStore.setIndex(index);
    photoStore.showBigPhoto = true;
}

onMounted(() => {
    photoStore.populateImages();
});


return { __sfc: true,photoStore, clickedImage }
}

})